export const textCenter = () => ({
  textCenter: true
});